export default {
  seeCoverageDetails: {
    id: 'insurance_policy_details_see_coverage_details',
    defaultMessage: 'See coverage details',
  },
  coverageDetailsDrawerTitle: {
    id: 'insurance_policy_details_coverage_details_drawer_title',
    defaultMessage: 'Coverage details',
  },
  downloadTermsAndConditions: {
    id: 'insurance_policy_details_download_terms_and_conditions',
    defaultMessage: 'Download Terms and conditions',
  },
  downloadIpid: {
    id: 'insurance_policy_details_download_ipid',
    defaultMessage: 'Download IPID',
  },
  downloadBackmarketRecap: {
    id: 'insurance_policy_details_download_backmarket_recap',
    defaultMessage: 'Download Back Market recap',
  },
}
